"use strict";
/* eslint-disable @typescript-eslint/no-explicit-any */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalBehaviors = void 0;
var shared_1 = require("@cian/peperrors/shared");
var constants_1 = require("../constants");
var GlobalBehaviors = /** @class */ (function () {
    function GlobalBehaviors() {
        this.version = 0;
        this.state = {
            tasks: {},
            subscribers: {},
        };
    }
    GlobalBehaviors.prototype.migrate = function (prev) {
        this.state = prev.state;
    };
    GlobalBehaviors.prototype.subscribe = function (taskName, subscriber) {
        var task = this.getTask(taskName);
        var subscribers = this.ensureSubscribers(taskName);
        subscribers.push(subscriber);
        if (task) {
            if (task.onSubscribe) {
                task.onSubscribe();
            }
        }
    };
    GlobalBehaviors.prototype.unsubscribe = function (taskName, subscriber) {
        var task = this.getTask(taskName);
        var subscribers = this.ensureSubscribers(taskName);
        this.state.subscribers[taskName] = subscribers.filter(function (item) { return item !== subscriber; });
        if (task) {
            if (task.onUnsubscribe) {
                task.onUnsubscribe();
            }
        }
    };
    GlobalBehaviors.prototype.register = function (task) {
        var state = this.state;
        var key = task.key;
        var currentTask = state.tasks[key];
        if (!currentTask) {
            state.subscribers[key] = [];
        }
        if (currentTask) {
            if (task.version <= currentTask.version) {
                return;
            }
            if (task.migrate) {
                task.migrate(currentTask);
            }
            if (currentTask.onDestroy) {
                currentTask.onDestroy();
            }
        }
        state.tasks[key] = task;
        if (task.onRegister) {
            task.onRegister();
        }
    };
    GlobalBehaviors.prototype.getSubscribers = function (taskName) {
        var subscribers = this.state.subscribers[taskName];
        if (!subscribers) {
            throw new shared_1.ValidationError({
                message: "\u041D\u0435\u0442 \u0437\u0430\u0434\u0430\u0447\u0438 \u0441 \u0438\u043C\u0435\u043D\u0435\u043C " + taskName,
                domain: constants_1.ERRORS_DOMAIN,
            });
        }
        return subscribers;
    };
    GlobalBehaviors.prototype.getTask = function (taskName) {
        return this.state.tasks[taskName];
    };
    GlobalBehaviors.prototype.ensureSubscribers = function (taskName) {
        var subscribers = this.state.subscribers[taskName] || [];
        this.state.subscribers[taskName] = subscribers;
        return subscribers;
    };
    return GlobalBehaviors;
}());
exports.GlobalBehaviors = GlobalBehaviors;
//# sourceMappingURL=GlobalBehaviors.js.map